/**
 * @requires ./frc.js
 * @requires ./frc.utilities.js
 * @requires ./frc.api.js
 */

 frc.pages.contactReview = {
 	"data": {},
 	"init": function(){
		frc.page = frc.pages.contactReview;
		new frc.modules.contactReview(".form");
 	}
};
